import { render } from "./ForgottenPasswordContainer.vue?vue&type=template&id=934e3fdc"
import script from "./ForgottenPasswordContainer.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__